module.exports = __webpack_public_path__ + "static/sante-73280565ddfc59c974deb3ddf1bfcb0c.svg";